import {BaseAttribute, BaseAttributeOptions} from '../BaseAttribute';

export type DateBaseAttributeOptions = BaseAttributeOptions;

// Base class for all date-like attributes (date, datetime, datetime-seconds).
export class DateBaseAttribute extends BaseAttribute {
  constructor(options: DateBaseAttributeOptions = {}) {
    super(options);
  }

  getInitialValue(): unknown {
    // BaseAttribute defaults creationValue to null when omitted, so null must
    // keep meaning "use today". Use false as the opt-out for an empty date.
    if (this.creationValue === false) {
      return null;
    }
    return this.creationValue ? this.creationValue : new Date();
  }

  /** By default, date attributes are converted into Date objects with time */
  toDbValue(value: unknown): [unknown, unknown] {
    if (!value) return [null, null];
    let date = null;
    if (value instanceof Date) date = value;
    if (typeof value === 'string' || typeof value === 'number')
      date = new Date(value);
    if (date) return [date, date];
    return [null, null];
  }

  /** Converts the value from the database to a value that can be used in the UI */
  toLocalValue(item: Record<string, unknown>): unknown {
    let value = item[this.name];
    if (!value && this.column) {
      value = item[this.column];
    }
    if (!value) return null;
    if (this.transform) {
      value = this.transform(value);
    }
    return new Date(value as string);
  }
}
